import { render, staticRenderFns } from "./otd.vue?vue&type=template&id=5509c61d"
import script from "./otd.vue?vue&type=script&lang=ts"
export * from "./otd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports